import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormContext, useWatch } from 'react-hook-form';
import PropTypes from 'prop-types';
import { Button } from 'next-common-lib';
import i18n from 'i18n';
import { SIGNUP_RADIO_ERROR } from 'constants/IncorporationConstants';
import TblRowHeader from 'components/IncorporationOfTerms/Register/FormAtoms/TblRowHeader';
import TblRowTail from 'components/IncorporationOfTerms/Register/FormAtoms/TblRowTail';
import TblRow from 'components/IncorporationOfTerms/Register/FormAtoms/TblRow';
import RadioForm from 'components/IncorporationOfTerms/Register/FormAtoms/RadioForm';
import TextFieldHookForm from 'components/Common/InputBox/TextFieldHookForm';
import PhoneNumberHookForm from 'components/IncorporationOfTerms/Register/FormMolecules/PhoneNumberHookForm';
import FormTitle from 'components/IncorporationOfTerms/Register/FormAtoms/FormTitle';
import InputButtonRow from 'components/IncorporationOfTerms/Register/FormAtoms/InputButtonRow';
import AlertInfo from 'components/IncorporationOfTerms/Register/FormAtoms/AlertInfo';
import * as accountActions from 'redux/ducks/Employee/AccountDucks';
import * as alertActions from 'redux/ducks/common/alertDucks';

const OTP_PERIOD_IN_SECOND = 180;
export const AuthForm = ({ disabled }) => {
  const dispatch = useDispatch();
  const [authKey, setAuthKey] = useState(0);
  const { isSendOtp, employeeVo, incorrectOTPcount } = useSelector(state => state.account);
  const { getValues, setValue } = useFormContext();
  const authTarget = useWatch({ name: 'authTarget' });

  const authHandleOnClick = value => {
    if (!value) {
      dispatch(
        alertActions.open({
          isDimed: true,
          message: [SIGNUP_RADIO_ERROR[authTarget]],
        }),
      );
      return;
    }
    const payload = {
      option: authTarget,
      locale: 'ko',
      optionValue: value,
    };
    if (value !== 'epOpenCode') {
      setAuthKey(Math.random());
    }
    dispatch(accountActions.getNewEmployee(payload));
  };

  const otpAuthInput = () => {
    return (
      <TblRow key={authKey}>
        <TblRowHeader rowHeader="MB_T_OTP_NUMBER" isRequired />
        <TblRowTail
          formClass="form-field-multi"
          buttonChildren={
            <Button
              componentType="solid"
              className="primary ie-btn"
              label={i18n.t('MB_T_AUTHCATION')}
              disabled={disabled}
              onClick={() => {
                const payload = {
                  opt: getValues('opt'),
                  epid: employeeVo.epid,
                };
                dispatch(accountActions.checkOtp(payload));
              }}
            />
          }
        >
          <TextFieldHookForm
            componentType={isSendOtp ? 'inputTimer' : 'input'}
            timerCount={`${OTP_PERIOD_IN_SECOND}`}
            name="opt"
            className="type-full"
            maxLength={50}
            disabled={disabled}
            timerCallback={() => {
              dispatch(accountActions.setIsSendOtp(!isSendOtp));
            }}
          />
        </TblRowTail>
      </TblRow>
    );
  };

  useEffect(() => {
    setValue('mobile', '');
    setValue('epExternalMail', '');
    setValue('opt', '');
  }, [authTarget]);

  useEffect(() => {
    if (employeeVo.xtnlEmailAddr) {
      setValue('xtnlEmailAddr', employeeVo.xtnlEmailAddr);
    }
    if (employeeVo.mphonNo || employeeVo.option === 'mobile') {
      setValue('mphonNo', employeeVo.mphonNo ? employeeVo.mphonNo : employeeVo.optionValue);
    }
  }, [employeeVo]);

  useEffect(() => {
    if (incorrectOTPcount >= 4) {
      dispatch(accountActions.setIsSendOtp(!isSendOtp));
      dispatch(
        alertActions.open({
          message: ['MB667'],
        }),
      );
    }
  }, [incorrectOTPcount]);

  return (
    <div className="form-section">
      <FormTitle title="MB_T_IDENTITY_VERIF" isRequired />
      <ul className="form-table">
        <TblRow>
          <TblRowHeader rowHeader="MB_T_AUTHCATION_METHOD" isRequired />
          <TblRowTail unUsedInputBox>
            <div className="radio-box">
              <RadioForm
                name="authTarget"
                items={[
                  { value: 'epOpenCode', label: 'MB_T_EMP_CERT_KEY', title: 'MB_T_EMP_CERT_KEY' },
                  { value: 'epExternalMail', label: 'MB_T_EMP_EX_EMAIL', title: 'MB_T_EMP_EX_EMAIL' },
                  {
                    value: 'mobile',
                    label: 'MB_T_EMP_MOBILE',
                    title: 'MB_T_EMP_MOBILE',
                  },
                ]}
                isDisable={disabled || isSendOtp}
              />
            </div>
          </TblRowTail>
        </TblRow>
        {authTarget === 'mobile' && (
          <TblRow>
            <TblRowHeader rowHeader="MB_T_EMP_MOBILE" />
            <TblRowTail
              formClass="form-field-multi"
              unUsedInputBox
              guideText={<AlertInfo alertText="MB_T_APPLY_PHONE" />}
              buttonChildren={
                <Button
                  componentType="solid"
                  className="primary ie-btn"
                  label={i18n.t('MB_T_AUTHCATION_SEND')}
                  disabled={disabled || isSendOtp}
                  onClick={() => {
                    authHandleOnClick(`${getValues('mobile')}`);
                  }}
                />
              }
            >
              <>
                <PhoneNumberHookForm name="mobile" disabled={disabled} values={getValues('mobile')} />
              </>
            </TblRowTail>
          </TblRow>
        )}
        {authTarget === 'epExternalMail' && (
          <InputButtonRow
            header="MB_T_EMP_EX_EMAIL"
            name="epExternalMail"
            isRequired
            btnLabel={i18n.t('MB_T_AUTHCATION_SEND')}
            disabled={disabled || isSendOtp}
            guideText={<AlertInfo alertText="MB_T_APPLY_EMAIL" />}
            btnAction={() => {
              authHandleOnClick(getValues('epExternalMail'));
            }}
          />
        )}
        {authTarget === 'epOpenCode' && (
          <InputButtonRow
            header="MB_T_EMP_CERT_KEY"
            name="opt"
            isRequired
            btnLabel={i18n.t('MB_T_AUTHCATION')}
            disabled={disabled}
            guideText={<AlertInfo alertText="MB_T_APPLY_ID" />}
            btnAction={() => {
              authHandleOnClick(getValues('opt'));
            }}
          />
        )}
        {authTarget !== 'epOpenCode' && isSendOtp && otpAuthInput()}
      </ul>
    </div>
  );
};
AuthForm.propTypes = { disabled: PropTypes.bool };
AuthForm.defaultProps = { disabled: false };
export default AuthForm;
